import { createFunnelPageConfig, LandingPageKind, templateSection, type LandingTemplate } from "../../template";

/**
 * Copy of `BikiniLandingPage` (`apps/ecommerce/src/modules/v2/Bikini`) as rendered on the
 * dynamic funnel route, variant A (PostHog `bikini-landing-variant` off). The variant B
 * blocks are in the template too, switched off.
 */

const WP = "https://metamorfoza.programhollywood.pl/wp-content/uploads/2025/09";
const BUILDER = "https://api.builder.io/api/v1/image/assets/TEMP";

const SEO_DESCRIPTION =
  "Dołącz do ponad 5,000 kobiet i dokonaj szybkiej metamorfozy swojej sylwetki 100% online! Dokonaj szybkiej metamorfozy swojej sylwetki!";
const OG_IMAGE =
  "https://imqwfnfhoivklhutcolk.supabase.co/storage/v1/object/public/shared/cb81bd59-fec3-41de-8ef1-49d680c0c7d3/products/rc-upload-1758784151468-3-rc_upload_1757795955237_6_Group_60.png";

export const bikiniHeroProps = {
  title: "<em>6 tygodni</em> do bikini w domu",
  imageLeft: `${WP}/group-42.png`,
  imageRight: `${WP}/group-43.png`,
  imageMobile: `${BUILDER}/1d87c3f2535113ed057272f2bc7716e2e6058f6e?width=1048`,
  labels: [
    { text: "Natychmiastowe rezultaty", icon: "clock" },
    { text: "Osiągnij efekty = uzyskaj 300% dofinansowania!", icon: "handCoins" },
    { text: "Sekret tkwi w prostocie", icon: "salad" },
  ],
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniBoxesProps = {
  className: "bg-white",
  items: [
    {
      icon: "clock",
      title: "NATYCHMIASTOWE REZULTATY",
      text: "Używając fizjologicznych metod takich jak odwrotne ładowanie węglowodanami w połączeniu z ćwiczeniami HIIT osiągniesz zaskakująco szybkie efekty!",
      background: "#FDF2F8",
    },
    {
      icon: "handCoins",
      title: "OSIĄGNIJ EFEKTY = UZYSKAJ 300% DOFINANSOWANIA!",
      text: "Schudnij 5 kg lub wykonaj 90% treningów - a uzyskasz 300% dofinansowania do dalszej metamorfozy w Programie Budowy Sylwetki Hollywood!",
      background: "#FCE7F3",
    },
    {
      icon: "salad",
      title: "SEKRET TKWI W PROSTOCIE",
      text: "Nie potrzebujesz siłowni, ani godzin spędzonych w kuchni. To plan, który zrealizujesz nawet przy dzieciach, pracy i braku czasu.",
      background: "#FDF2F8",
    },
  ],
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniVideoProps = {
  title: "Obejrzyj film i <em>schudnij z gwarancją uzyskania efektów!</em>",
  videoId: "k6r7vnb8jy",
  background: "#FFEEEE",
  className: "bg-pink-light",
  overlayTitle: "",
  caption: "",
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniMetamorphosesProps = {
  title: "Wyzwanie 6 Tygodni Do Bikini",
  className: "bg-white py-16",
  mode: "images",
  images1: [
    { image: `${WP}/frame-1000006140-8.png` },
    { image: `${WP}/frame-1000006180-5.png` },
    { image: `${WP}/frame-1000006140-9.png` },
    { image: `${WP}/screenshot-2025-09-05-at-09.22.19-1.png` },
    { image: `${WP}/frame-1000006139-7.png` },
    { image: `${WP}/frame-1000006139-6.png` },
    { image: `${WP}/frame-1000006180-4.png` },
  ],
  images2: [
    { image: `${WP}/frame-1000006141-1.png` },
    { image: `${WP}/frame-1000006183.png` },
    { image: `${WP}/frame-1000006140-3.png` },
  ],
  cards1Set: "topHero",
  cards1Ids: [],
  cards2Set: "topStatistics",
  cards2Ids: [],
  description1: [
    {
      text: "Jesteś zmęczona nieefektywnymi treningami i monotonną dietą, która nie przynosi rezultatów? Masz dość wydawania pieniędzy na magiczne tabletki i szejki? Nie masz czasu by trenować codziennie i szukasz najszybszej metody na spalenie tłuszczu i wysmuklenie swoich mięśni?",
    },
    {
      text: "Zapraszam Cię do Wyzwania <strong>6 Tygodni Do Bikini</strong>, które ukończyło ponad 10,000 kobiet, osiągając rewelacyjne wyniki.",
    },
  ],
  description2: [
    {
      text: "Wyzwanie <strong>6 Tygodni do Bikini</strong> to prosty program on-line dla kobiet, które chcą szybko zgubić do 10 kg wagi. Wyzwanie zawiera wszystko czego potrzebujesz, aby zbudować trwałe nawyki żywieniowe, zredukować oporną tkankę tłuszczową i wysmuklić mięśnie.",
    },
    {
      text: "<strong>To czas, aby dokonać trwałej metamorfozy Twojej sylwetki!</strong><br />Bez monotonnej diety. Bez nieefektywnych treningów. Bez efektu jojo.<br />Dołącz do tysięcy zadowolonych kobiet!",
    },
  ],
};

export const bikiniStatNumbersProps = {
  items: [
    { value: "12 000", label: "kobiet ukończyło wyzwanie" },
    { value: "5 kg", label: "średnia utrata wagi" },
    { value: "441 zł", label: "nagroda za osiągnięty cel" },
  ],
};

export const bikiniWaysProps = {
  title: "Możesz tylko wygrać",
  subtitle: "Tak czy tak - obie drogi są wygraną",
  ways: [
    {
      label: "Droga A",
      title: "Metamorfoza",
      steps: [
        "Dołączasz do wyzwania 6 Tygodni do Bikini",
        "Wykonujesz program w swoim tempie",
        "Czujesz się lepiej, widzisz pierwsze efekty",
      ],
      result: "Wygrywasz sylwetkę i zdrowie",
      background: "#1A1235",
      resultStyle: "soft",
    },
    {
      label: "Droga B",
      title: "Wielki Finał z nagrodą",
      steps: [
        "Dołączasz do wyzwania 6 Tygodni do Bikini",
        "Chudniesz 5 kg lub robisz 90% treningów",
        "Twoja inwestycja się potraja",
      ],
      result: "441 zł na Program Hollywood",
      background: "#F13268",
      resultStyle: "bold",
    },
  ],
  buttonText: "Biorę udział w metamorfozie →",
  note: "147 zł · natychmiastowy dostęp · bez ryzyka",
  href: "",
};

const includedBox = (image: string, title: string, text: string) => ({ image, imageMobile: image, title, text });

export const bikiniIncludedProps = {
  title: "Co znajdziesz w wyzwaniu?",
  background: "#FFEEEE",
  className: "bg-pink-light",
  boxes1: [
    includedBox(
      `${BUILDER}/5065f69e1cafdb4e184f1db2c48d89d8ec1847ac?width=656`,
      "Osiągnij efekty, a dofinansujemy o 300% Twoją metamorfozę!",
      "Jeżeli schudniesz 5 kg, lub wykonasz 90% treningów - otrzymasz od nas 300% dofinansowania na dalszą metamorfozę w Programie Budowy Sylwetki Hollywood!",
    ),
    includedBox(
      `${BUILDER}/bf11227f1f00620b85ea0e864d3268b879bc6881?width=646`,
      "Nogi, pośladki, brzuch",
      "Treningi ukierunkowane na budowę sylwetki plażowej",
    ),
    includedBox(
      `${BUILDER}/ee304a7cbeec0b563062310f4f6833dc47953fad?width=640`,
      "Odwrotne ładowanie węglowodanami",
      "Aby nie odczuwać głodu na diecie",
    ),
    includedBox(
      `${BUILDER}/a16dbbce79923740a8497906f2c2c89140d9295f?width=699`,
      "Sprawdzone treningi hybrydowe",
      "Oszczędzaj czas - trenuj bez siłowni",
    ),
  ],
  boxes2: [
    includedBox(
      `${BUILDER}/cbe577cb152e4fb0e913e01f4aaf1112b26ecee9?width=642`,
      "Budowanie sylwetki klepsydry",
      "Zbuduj wymarzone proporcje",
    ),
    includedBox(
      `${BUILDER}/4b799a8a8841b7acc647c0224b6034e0a49e8e42?width=720`,
      "Bez rezygnowania",
      "Ze słodyczy, prosecco, czekolady",
    ),
    includedBox(
      `${BUILDER}/2c6da45a3aeab0632ed1824f0a7ec6daedc602f6?width=986`,
      "Nauka techniki",
      "Dostęp do profesjonalnej demonstracji ćwiczeń",
    ),
    includedBox(
      `${BUILDER}/a9866590e1550cea35065b2ae7efc76567174880?width=700`,
      "Najprostsza dieta na świecie",
      "Do przygotowania w 20 min dziennie",
    ),
    includedBox(`${WP}/frame-1000006150-7.png`, "Prywatna grupa", "Poznaj tysiące kobiet z tymi samymi celami, co Ty"),
  ],
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniHowItWorksProps = {
  title: "Jak <em>wyzwanie Bikini</em> wygląda w całości?",
  background: "#fff",
  boxes1: [
    {
      image1: `${WP}/group-10-1.png`,
      image2: `${WP}/group-11.png`,
      text: "Jedyne w Polsce wyzwanie z Gwarancją Rezultatów! Schudnij 5 kg lub wykonaj 90% planu, a otrzymasz 300% dofinansowania do dalszej metamorfozy w Programie Budowy Sylwetki Hollywood®.",
    },
    {
      image1: `${WP}/group-12.png`,
      image2: `${WP}/group-13.png`,
      text: "Ćwiczenia trwają tylko 45 minut, a spalają tłuszcz nawet przez 4h. Możesz trenować w domu, lub na siłowni.",
    },
    {
      image1: `${WP}/group-37.png`,
      image2: `${WP}/group-38.png`,
      text: " Podniesiesz pośladki, zarysujesz talię, wysmuklisz ramiona i pozbędziesz się cellulitu - bez godzin cardio.",
    },
    {
      image1: `${WP}/group-12-1.png`,
      image2: `${WP}/group-13-1.png`,
      text: "Dieta mięsna lub bezmięsna. Produkty kupisz w każdym sklepie. Zero egzotyki.",
    },
  ],
  boxes2: [
    {
      image1: `${WP}/group-12-2.png`,
      image2: `${WP}/group-13-2.png`,
      text: "Pozbędziesz się całkowicie głodu i napadów na słodkie, dzięki naukowej metodzie odwrotnego ładowania węglowodanami.",
    },
    {
      image1: `${WP}/group-10-2.png`,
      image2: `${WP}/group-11-1.png`,
      text: "Poznasz najlepsze (i tanie) suplementy, które drastycznie przyspieszają efekty.",
    },
    {
      image1: `${WP}/group-10-3.png`,
      image2: `${WP}/group-11-2.png`,
      text: " Wydłużysz fazę snu głębokiego - czyli zyskasz więcej siły na co dzień (bez kawy litrami).",
    },
    {
      image1: `${WP}/group-10-4.png`,
      image2: `${WP}/group-11-3.png`,
      text: "Proste, konkretne metody krok po kroku. Wszystko w VIP aplikacji mobilnej, bez dziesiątek plików PDF.",
    },
  ],
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniPriceBannerProps = {
  title: "Zacznij już teraz 🔥",
  priceText: "Obniżona cena z <s>{{cenaPrzedRabatem}}</s> na <strong>{{cena}}!</strong>",
  priceTextWithoutDiscount: "<strong>{{cena}}</strong>",
  priceTextWithoutFunnel: "Obniżona cena z <s>597 zł</s> na <strong>147 zł!</strong>",
  background: "linear-gradient(94deg, #FFB9BD 0.01%, #FFD9D1 51.45%, #FFB9BD 96.16%)",
  buttonText: "Tak! Jestem gotowa na metamorfozę!",
  href: "",
};

export const bikiniFeaturesProps = {
  title: "Program stworzony, aby rozpocząć <em>ostateczną metamorfozę sylwetki!</em>",
  itemsTop: [
    {
      emoji: "🔥",
      title: "Innowacyjne metody odchudzające",
      text: "Zapomnij o długich sesjach cardio - wystarczy Ci 45 min co drugi dzień na trening.",
    },
    {
      emoji: "🍎",
      title: "Regulowanie poziomu glukozy",
      text: "Stabilny poziom glukozy we krwi to pewność, że nie będziesz głodna na diecie. Dzięki temu nie będziesz miała ochoty na słodycze, ani podjadanie.",
    },
  ],
  itemsBottom: [
    {
      emoji: "🍑",
      title: "Wąska talia, szczupłe nogi i zarysowany brzuch",
      text: "Dzięki takiej sylwetce, każdy kostium kąpielowy będzie wyglądał na Tobie idealnie! Program 6 tygodni do bikini zawiera protokół, który pozwoli na zbudowanie odstających pośladków i zmniejszenie obwodu talii.",
    },
    {
      emoji: "🕓",
      title: "Krótki czas w kuchni",
      text: "Przepisy które znajdziesz w programie, będą bardzo łatwe do przygotowania i nie będą wymagać długich godzin spędzonych w kuchni. Wszyscy domownicy będą mogli korzystać z potraw które przygotujesz.",
    },
    {
      emoji: "💪🏼",
      title: "Gwarantowane efekty",
      text: "Zależy nam na Twojej metamorfozie, dlatego jeżeli podczas wyzwania zgubisz 5 kg lub wykonasz 90% treningów - potroimy Twoją inwestycję na dalszą metamorfozę w Programie Budowy Sylwetki Hollywood!",
    },
  ],
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniNonForbiddenProductsProps = {
  title: "To NIE są zakazane produkty",
  items: [
    { image: `${WP}/group-47.png`, alt: "metamorfoza", width: 138, height: 136, mobileWidth: 120, mobileHeight: 120 },
    { image: `${WP}/group-46.png`, alt: "metamorfoza", width: 136, height: 136, mobileWidth: 120, mobileHeight: 120 },
    { image: `${WP}/group-45.png`, alt: "metamorfoza", width: 239, height: 114, mobileWidth: 180, mobileHeight: 100 },
    { image: `${WP}/group-44.png`, alt: "metamorfoza", width: 117, height: 136, mobileWidth: 100, mobileHeight: 120 },
  ],
  buttonText: "Użyj ich w swojej diecie",
  href: "",
};

const recommendation = (image: string, name: string) => ({
  image,
  name,
  caption: "Uczestniczka Programu Budowy Sylwetki Hollywood",
});

export const bikiniRecommendationsProps = {
  title: "Program online <em>6 Tygodni do Bikini</em>",
  items: [
    recommendation(`${WP}/frame-1000006139-5.png`, "Agnieszka"),
    recommendation(`${WP}/frame-1000006180-3.png`, "Kinga"),
    recommendation(`${WP}/frame-1000006180-2.png`, "Małgorzata"),
    recommendation(`${WP}/frame-1000006139-4.png`, "Magdalena"),
    recommendation(`${WP}/frame-1000006179.png`, "Ewa"),
    recommendation(`${WP}/frame-1000006180-1.png`, "Joanna"),
  ],
  description:
    "<strong>Wyzwanie 6 Tygodni do Bikini</strong> to samodzielny program online, który pomógł już tysiącom kobiet wrócić do formy i odzyskać kontrolę nad swoim ciałem.<br /><br />Powstał on w oparciu o systemy wykorzystywane w Programie Budowy Sylwetki Hollywood - który przeprowadził największą ilość metamorfoz kobiet w wieku 35-60 lat.<br /><br />Jeśli ten samodzielny plan zadziała u Ciebie - a jesteśmy przekonani, że tak - to rozpoczniesz ostateczną metamorfozę swojej sylwetki. Wszystko zaczyna się tutaj: samodzielnie, spokojnie - w Twoim tempie.<br /><br /><strong>Zacznij 6 Tygodni do Bikini</strong> - i zobacz, gdzie Cię to zaprowadzi.",
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniMoneyBackProps = {
  title: "Osiągnij minimalne efekty, <em>a potroimy Twoją inwestycję!</em>",
  text: "Jeżeli podczas wyzwania zgubisz 5 kg lub wykonasz 90% treningów - <strong>otrzymasz od nas 300% dofinansowania</strong> swojej inwestycji na dalszą metamorfozę w Programie Budowy Sylwetki Hollywood.",
  imageMobile: `${BUILDER}/65ae94cab0ec0e75b8990ac3a49a8c78749768ad?width=254`,
  imageDesktop: `${BUILDER}/772cd4b4df67585bfae83a84d6b3516b2d8fe668?width=521`,
  imageAlt: "Piggy bank with coins",
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniFaqProps = {
  title: "Najczęściej zadawane pytania",
  items: [
    {
      question: "Czy naprawdę mogę wygrać swoją metamorfozę?",
      answer:
        "Tak. Jeżeli zgubisz 5 kg, lub wykonasz 90% treningów - zwiększymy o 300% Twoją inwestycję na uczestnictwo w Programie Budowy Sylwetki Hollywood.",
    },
    {
      question: "Jakie efekty mogę osiągnąć w 6 tygodni?",
      answer:
        "W ciągu 6 tygodni możesz stracić od 3-8 kg, zmniejszyć obwód talii o 5-15 cm i znacząco poprawić kondycję fizyczną. Efekty zależą od Twojego zaangażowania i przestrzegania planu.",
    },
    {
      question: "Czy znajdę czas na dietę i trening?",
      answer:
        "Treningi trwają tylko 45 minut co drugi dzień, a przepisy są proste i szybkie w przygotowaniu. Program został stworzony z myślą o zajętych kobietach.",
    },
    {
      question: "Czy będę miała wsparcie?",
      answer:
        "Tak! Otrzymasz dostęp do prywatnej grupy Facebook, gdzie znajdziesz wsparcie innych uczestniczek oraz dostęp do ekspertów od żywienia i treningu.",
    },
    {
      question: "Co jeśli nie osiągnę efektów?",
      answer:
        "Program został przetestowany przez tysiące kobiet z pozytywnymi wynikami. Jeśli będziesz przestrzegać planu, efekty są praktycznie gwarantowane.",
    },
  ],
  openFirst: true,
  buttonText: "Biorę udział w metamorfozie",
  href: "",
};

export const bikiniFooterProps = {
  termsLabel: "Regulamin",
  termsUrl: "/pdf/regulamin-bikini.pdf",
  privacyLabel: "Polityka prywatności",
  privacyUrl: "/pdf/polityka-prywatnosci-bikini.pdf",
  facebookUrl: "https://www.facebook.com/michalbienkotrener",
  instagramUrl: "https://www.instagram.com/michalbienko/",
  youtubeUrl: "https://www.youtube.com/@michabienko",
  scrollToTopOffset: "bottom-8",
};

export const bikiniStickyBarProps = {
  title: "6 tygodni do Bikini",
  oldPrice: "597 zł",
  price: "147 zł",
  ctaText: "Biorę udział →",
  ctaTextCompact: "",
  href: "",
};

const createBikiniLandingConfig = (metamorphoses: "images" | "hollywood") =>
  createFunnelPageConfig({
    title: "6 tygodni do bikini",
    description: SEO_DESCRIPTION,
    ogImage: OG_IMAGE,
    pageName: "6tygodnidobikini-start",
    shell: "none",
    backgroundClassName: "landing-font min-h-screen bg-white",
    sections: [
      templateSection("bikini-effects", "funnelLandingEffects", { stepSlug: "landing", facebookPixel: true }),
      templateSection("bikini-hero", "bikiniHero", bikiniHeroProps),
      templateSection("bikini-boxes", "bikiniBoxes", bikiniBoxesProps),
      templateSection("bikini-video", "bikiniVideo", bikiniVideoProps),
      templateSection("bikini-metamorphoses", "bikiniMetamorphoses", {
        ...bikiniMetamorphosesProps,
        mode: metamorphoses,
      }),
      templateSection("bikini-stat-numbers", "bikiniStatNumbers", bikiniStatNumbersProps, { enabled: false }),
      templateSection("bikini-ways", "bikiniWays", bikiniWaysProps, { enabled: false }),
      templateSection("bikini-included", "bikiniIncluded", bikiniIncludedProps),
      templateSection("bikini-how-it-works", "bikiniHowItWorks", bikiniHowItWorksProps),
      templateSection("bikini-price-banner", "bikiniPriceBanner", bikiniPriceBannerProps),
      templateSection("bikini-features", "bikiniFeatures", bikiniFeaturesProps),
      templateSection("bikini-non-forbidden-products", "bikiniNonForbiddenProducts", bikiniNonForbiddenProductsProps),
      templateSection("bikini-recommendations", "bikiniRecommendations", bikiniRecommendationsProps),
      templateSection("bikini-money-back", "bikiniMoneyBack", bikiniMoneyBackProps),
      templateSection("bikini-faq", "bikiniFaq", bikiniFaqProps),
      templateSection("bikini-footer", "bikiniFooter", bikiniFooterProps),
      templateSection("bikini-sticky-bar", "bikiniStickyBar", bikiniStickyBarProps, { enabled: false }),
    ],
  });

export const bikiniTemplates: LandingTemplate[] = [
  {
    key: "bikini-landing",
    name: "6 Tygodni do Bikini - landing",
    kind: LandingPageKind.Landing,
    sourceRoute: "/oferta/6tygodnidobikini-promocja/start",
    config: createBikiniLandingConfig("images"),
  },
  {
    key: "bikini-landing-nowe-metamorfozy",
    name: "6 Tygodni do Bikini - nowe metamorfozy",
    kind: LandingPageKind.Landing,
    sourceRoute: "/oferta/6tygodnidobikini-promocja/start",
    config: createBikiniLandingConfig("hollywood"),
  },
];
